import { render, staticRenderFns } from "./bidOpeningItem.vue?vue&type=template&id=6cfd11c5&"
import script from "./bidOpeningItem.vue?vue&type=script&lang=js&"
export * from "./bidOpeningItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports